import ContentfulTextBasedSocialProof from './ContentfulTextBasedSocialProof';
import ContentfulDynamicHero from './ContentfulDynamicHero';
import ContentfulAccordion from './ContentfulAccordion';
import ContentfulContentBlock from './ContentfulContentBlock';
import ContentfulConversionPanel from './ContentfulConversionPanel';
import Contentful2ColumnLayout from './Contentful2ColumnLayout';
import ContentfulCardsBlock from './ContentfulCardsBlock';
import ContentfulTrustbar from './ContentfulTrustbar';
import ContentfulToggle from './ContentfulToggle';
import ContentfulEmbedCode from './ContentfulEmbedCode';
import ContentfulRowContent from './ContentfulRowContent';
import ContentfulTool from './ContentfulTool';
import ContentfulInPageFeatures from './ContentfulInPageFeatures';
import ContentfulRow from './ContentfulRow';
import ContentfulSection from './ContentfulSection';
import ContentfulCarousel from './ContentfulCarousel';
import ContentfulLayout from './ContentfulLayout';
import ContentfulTable from './ContentfulTable';
import ContentfulCallToAction from './ContentfulCallToAction';
import ContentfulHeader from './ContentfulHeader';

export const ComponentMap = {
  Contentful2ColumnLayout,
  ContentfulAccordion,
  ContentfulCallToAction,
  ContentfulCardsBlock,
  ContentfulCarousel,
  ContentfulContentBlock,
  ContentfulConversionPanel,
  ContentfulDynamicHero,
  ContentfulEmbedCode,
  ContentfulHeader,
  ContentfulInPageFeatures,
  ContentfulLayout,
  ContentfulRow,
  ContentfulRowContent,
  ContentfulSection,
  ContentfulTable,
  ContentfulTextBasedSocialProof,
  ContentfulToggle,
  ContentfulTool,
  ContentfulTrustbar,
};
